<template>
  <div class="tags-view-container">
    <scroll-pane class="tags-view-wrapper" ref="scrollPane" :class="tabNum == 2 ? 'active' : ''">
      <img src="@/assets/home/logo.png" class="logo" v-if="tabNum != 2" />
      <font class="title" v-if="tabNum != 2">后台管理</font>
      <font class="title" v-else>浙里问学</font>

      <!-- 横向导航 -->
      <router-link ref="tag" class="tags-view-item" :class="isActive(tag) ? 'active' : ''"
        v-for="tag in Array.from(visitedViews)" :to="tag.path" :key="tag.path"
        @contextmenu.prevent.native="openMenu(tag, $event)">
        {{ tag.title }}
        <span class="el-icon-close" @click.prevent.stop="closeSelectedTag(tag)"></span>
      </router-link>

      <el-menu class="navbar">
        <div class="right-menu">
          <el-dropdown class="avatar-container right-menu-item" trigger="click">
            <div class="avatar-wrapper">
              <span>{{ area }} </span>
              <!-- <img class="user-avatar" :src="user.Head"> -->
              <img class="user-avatar" src="@/assets/img/tx_mr.png" alt="" />
              <i class="el-icon-caret-bottom"></i>
            </div>

            <el-dropdown-menu slot="dropdown">
              <router-link to="/" v-if="tabNum != 2">
                <el-dropdown-item> 后台管理 </el-dropdown-item>
              </router-link>
              <el-dropdown-item v-if="tabNum != 2">
                <span @click="showPwd"> 修改密码 </span>
              </el-dropdown-item>
              <router-link target="_blank" to="/bigScreen" v-if="tabNum != 2">
                <el-dropdown-item> 大屏统计 </el-dropdown-item>
              </router-link>
              <a target="_blank" href="https://datav.aliyuncs.com/share/746ff4afee35d20e3e801ef25a11ea22"
                v-if="tabNum != 2">
                <el-dropdown-item> 大屏统计V2 </el-dropdown-item>
              </a>
              <el-dropdown-item divided>
                <span @click="logout" style="display: block">退出登录</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-menu>
    </scroll-pane>
    <ul class="contextmenu" v-show="visible" :style="{ left: left + 'px', top: top + 'px' }">
      <li @click="closeSelectedTag(selectedTag)">Close</li>
      <li @click="closeOthersTags">Close Others</li>
      <li @click="closeAllTags">Close All</li>
    </ul>

    <el-dialog title="修改密码" :visible.sync="visiblePwd" width="30%" :append-to-body="true" :before-close="handleClose"
      :close-on-click-modal="false">
      <div class="password">
        <!-- <div class="title">修改密码</div> -->
        <div class="psw">
          <span>原密码：</span>
          <input type="password" v-model="psw" />
        </div>
        <div class="new-psw">
          <span>新密码：</span>
          <input type="password" v-model="newPsw" />
        </div>
        <div class="new-pswd">
          <span>确认新密码：</span>
          <input type="password" v-model="newPswd" />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button v-if="tabNum == 0" type="primary" @click="editPwd">
          确 定
        </el-button>
        <el-button v-else type="primary" @click="editQuPwd">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ScrollPane from "@/components/ScrollPane";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import ErrorLog from "@/components/ErrorLog";
import Screenfull from "@/components/Screenfull";
import LangSelect from "@/components/LangSelect";
import ThemePicker from "@/components/ThemePicker";
import TagsView from "./Navbar";
import qs from "qs";
export default {
  components: {
    ScrollPane,
    Breadcrumb,
    Hamburger,
    ErrorLog,
    Screenfull,
    LangSelect,
    ThemePicker,
    TagsView,
  },
  data() {
    return {
      visible: false,
      top: 0,
      left: 0,
      selectedTag: {},
      user: "",
      area: "",

      visiblePwd: false,
      psw: "",
      newPsw: "",
      newPswd: "",
      tabNum: localStorage.getItem("tabNum"),
    };
  },
  computed: {
    visitedViews() {
      return this.$store.state.tagsView.visitedViews;
    },
  },
  watch: {
    $route() {
      this.addViewTags();
      this.moveToCurrentTag();
    },
    visible(value) {
      if (value) {
        document.body.addEventListener("click", this.closeMenu);
      } else {
        document.body.removeEventListener("click", this.closeMenu);
      }
    },
  },
  mounted() {
    this.addViewTags();
    if (this.tabNum != 2) {
      this.user = JSON.parse(localStorage.getItem("userInfo"));
      this.area = JSON.parse(localStorage.getItem("userInfo")).areaName;
    }
  },
  methods: {
    generateRoute() {
      if (this.$route.name) {
        return this.$route;
      }
      return false;
    },
    isActive(route) {
      return route.path === this.$route.path || route.name === this.$route.name;
    },
    addViewTags() {
      const route = this.generateRoute();
      if (!route) {
        return false;
      }
      this.$store.dispatch("addVisitedViews", route);
    },
    moveToCurrentTag() {
      const tags = this.$refs.tag;
      this.$nextTick(() => {
        for (const tag of tags) {
          if (tag.to === this.$route.path) {
            this.$refs.scrollPane.moveToTarget(tag.$el);
            break;
          }
        }
      });
    },
    closeSelectedTag(view) {
      this.$store.dispatch("delVisitedViews", view).then((views) => {
        if (this.isActive(view)) {
          const latestView = views.slice(-1)[0];
          if (latestView) {
            this.$router.push(latestView.path);
          } else {
            this.$router.push("/");
          }
        }
      });
    },
    closeOthersTags() {
      this.$router.push(this.selectedTag.path);
      this.$store.dispatch("delOthersViews", this.selectedTag).then(() => {
        this.moveToCurrentTag();
      });
    },
    closeAllTags() {
      this.$store.dispatch("delAllViews");
      this.$router.push("/");
    },
    openMenu(tag, e) {
      this.visible = true;
      this.selectedTag = tag;
      this.left = e.clientX;
      this.top = e.clientY;
    },
    closeMenu() {
      this.visible = false;
    },
    toggleSideBar() {
      this.$store.dispatch("toggleSideBar");
    },
    logout() {
      if (this.tabNum != 2) {
        let token = localStorage.getItem("loginToken").slice(7);
        console.log(token.slice(7))
        this.axios.post('api/Manage/User/LogOut?token=' + token).then(res => {
          if (res.data.resultType == 0) {
            localStorage.removeItem('loginToken')
            localStorage.removeItem('tokenExpires')
            localStorage.removeItem('userInfo')
            this.$router.push('/login')
          } else {

          }
        })
      } else {
        this.$store.dispatch("LogOut").then(() => {
          location.reload(); // In order to re-instantiate the vue-router object to avoid bugs
        });
      }
    },

    //修改密码
    showPwd() {
      this.visiblePwd = true;
      console.log(this.tabNum);
    },
    editPwd() {
      if (this.psw == "" || this.newPsw == "" || this.newPswd == "") {
        this.$message.warning("密码不能为空");
        return;
      }
      if (this.psw == this.newPsw) {
        this.$message.warning("新密码不能与原密码相同");
        return;
      }
      if (this.newPsw != this.newPswd) {
        this.$message.warning("新密码两次不一样");
        return;
      }
      console.log(this.psw, this.newPsw, this.newPswd);
      this.axios
        .post(
          "api/Manage/Admins/ChangePwdPost",
          qs.stringify({
            PassWord: this.psw,
            NewPassWord: this.newPswd,
          })
        )
        .then((res) => {
          let data = res.data;
          console.log(data);
          if (data.resultType == 0) {
            this.$message.success("修改成功");
            this.psw = "";
            this.newPsw = "";
            this.newPswd = "";
            this.visiblePwd = false;
          } else {
            this.$message.error("修改失败");
            this.newPsw = "";
            this.newPswd = "";
          }
        })
        .catch((err) => {
          this.$alert(err);
        });
    },
    //区县修改密码
    editQuPwd() {
      if (this.psw == "" || this.newPsw == "" || this.newPswd == "") {
        this.$message.warning("密码不能为空");
        return;
      }
      if (this.psw == this.newPsw) {
        this.$message.warning("新密码不能与原密码相同");
        return;
      }
      if (this.newPsw != this.newPswd) {
        this.$message.warning("新密码两次不一样");
        return;
      }
      console.log(this.psw, this.newPsw, this.newPswd);
      this.axios
        .post(
          "api/DtMage/Admins/ChangePwdPost",
          qs.stringify({
            PassWord: this.psw,
            NewPassWord: this.newPswd,
          })
        )
        .then((res) => {
          let data = res.data;
          console.log(data);
          if (data.resultType == 0) {
            this.$message.success("修改成功");
            this.psw = "";
            this.newPsw = "";
            this.newPswd = "";
            this.visiblePwd = false;
          } else {
            this.$message.error("修改失败");
            this.newPsw = "";
            this.newPswd = "";
          }
        })
        .catch((err) => {
          this.$alert(err);
        });
    },
    handleClose() {
      this.$confirm("确认关闭？")
        .then((_) => {
          this.psw = "";
          this.newPsw = "";
          this.newPswd = "";
          this.visiblePwd = false;
        })
        .catch((_) => { });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.el-dialog__footer {
  text-align: center;
}

.password {
  >div {
    margin: 20px 0;

    span {
      display: inline-block;
      width: 20%;
      text-align: right;
    }

    input {
      border: 1px solid #aca6a6;
      padding: 5px;
      border-radius: 5px;
      width: 50%;
    }
  }
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
.tags-view-container {
  .logo {
    display: inline-block;
    transition: width 0.28s;
    width: 36px !important;
    height: 36px;
    margin-right: 10px;
    margin-left: 10px;
    vertical-align: sub;
  }

  .title {
    font-size: 26px;
    font-weight: bold;
    vertical-align: super;
  }

  .navbar {
    height: 50px;
    line-height: 50px;
    border-radius: 0px !important;
    background-color: #304156;
    position: fixed;
    top: 0;
    right: 0;
    z-index: 1001;
    width: 0;
    color: white;

    .errLog-container {
      display: inline-block;
      vertical-align: top;
      color: white;
    }

    .right-menu {
      color: white;
      float: right;
      height: 100%;

      &:focus {
        outline: none;
      }

      .right-menu-item {
        display: inline-block;
        margin: 0 8px;
        color: white;
      }

      .screenfull {
        height: 20px;
        color: white;
      }

      .international {
        vertical-align: top;
        color: white;
      }

      .theme-switch {
        vertical-align: 15px;
        color: white;
      }

      .avatar-container {
        height: 50px;
        margin-right: 30px;

        .avatar-wrapper {
          cursor: pointer;
          margin-top: 5px;
          position: relative;

          .user-avatar {
            width: 40px;
            height: 40px;
            border-radius: 10px;
            color: white;
          }

          .el-icon-caret-bottom {
            position: absolute;
            right: -20px;
            top: 25px;
            font-size: 12px;
            color: white;
          }
        }
      }
    }
  }

  .tags-view-wrapper {
    background: #304156;
    height: 60px;
    z-index: 9;
    // border-bottom: 1px solid #d8dce5;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.04);

    &.active {
      background: #fff;

      .title {
        color: #1492ff;
        margin: 0 30px;
      }
    }

    .tags-view-item {
      display: inline-block;
      position: relative;
      height: 26px;
      line-height: 26px;
      border: 1px solid #495060;
      color: #fff;
      background: #495060;
      padding: 0 8px;
      font-size: 12px;
      margin-left: 5px;
      margin-top: 4px;
      vertical-align: super;

      &:first-of-type {
        margin-left: 15px;
      }

      &.active {
        background-color: #42b983;
        color: #fff;
        border-color: #42b983;

        &::before {
          content: "";
          background: #fff;
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          position: relative;
          margin-right: 2px;
        }
      }
    }
  }

  .contextmenu {
    margin: 0;
    background: #fff;
    z-index: 2;
    position: absolute;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    color: #333;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);

    li {
      margin: 0;
      padding: 7px 16px;
      cursor: pointer;

      &:hover {
        background: #eee;
      }
    }
  }
}
</style>

<style rel="stylesheet/scss" lang="scss">
//reset element css of el-icon-close
.tags-view-wrapper {
  .tags-view-item {
    .el-icon-close {
      width: 16px;
      height: 16px;
      vertical-align: 2px;
      border-radius: 50%;
      text-align: center;
      transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
      transform-origin: 100% 50%;

      &:before {
        transform: scale(0.6);
        display: inline-block;
        vertical-align: -3px;
      }

      &:hover {
        background-color: #b4bccc;
        color: #fff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue